import { Link } from "react-router-dom";
import { Post } from "../../data-types/data-types";
interface PostCardI {
	responsive?: boolean,
	className?: string,
	data?: Post
}
const PostCard = ({ responsive, className = '', data }: PostCardI) => {
	return (
		<div className={`${className} text-slate-600 rounded dark:text-slate-300 transition duration-300 hover:bg-slate-50 dark:hover:bg-slate-800 group justify-between md:justify-start items-center flex flex-row-reverse space-x-2 ${responsive ? 'md:flex-col md:items-start' : ''}`}>
			<div className={`h-24 w-[6.5rem] min-w-[6.5rem] ${responsive ? 'lg:h-48 md:w-full' : ''} overflow-hidden rounded`}>
				<img src={data?.image ?? `https://images.unsplash.com/photo-1676371855313-a56044326d31?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw4fHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60`} alt="postImage" className="h-full transition duration-500 w-full object-cover bg-slate-200 dark:bg-slate-700 mb-5 rounded group-hover:scale-110 group-focus-within:scale-110" />
			</div>
			<div className={`p-1 max-w-full overflow-hidden ${responsive ? 'lg:py-3 lg:px-5' : ''} rounded-b`}>
				<div className="flex flex-wrap mb-2">
					<span className={`text-xs mb-1 mr-2 ${responsive ? ' lg:text-sm lg:mr-4' : ''}`}>
						<i className='bx bx-calendar mr-1'></i>
						{data?.date}
					</span>
					{/* <span className={`text-xs mb-1 ${responsive ? ' lg:text-sm' : ''}`}>
						<i className='bx bx-time mr-1' ></i>
						02 min read
					</span> */}
				</div>
				<Link to={`/blog/${data?.id}`} className="focus:outline-none group/post text-left">
					<h3 className={`text-black line-clamp-3 group-focus-visible/post:underline font-serif dark:text-white ${responsive ? 'lg:text-xl lg:my-3' : ''}`}>{data?.title}</h3>
					<p className={`my-2 text-sm line-clamp-2 hidden ${responsive ? 'lg:block' : ''}`} >
						{data?.description}
					</p>
				</Link>
				{/* <Link to={`/blog/author/felix`} className={`flex w-full text-left focused rounded ${responsive ? ' lg:space-x-4 mt-2 lg:my-4' : ''} items-center`}>
					<img src="https://plus.unsplash.com/premium_photo-1663013015949-d2df0c5a1fac?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxfHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60" alt="profile-img" className={`h-10 w-10 rounded-full object-cover hidden ${responsive ? 'lg:inline' : ''}`}></img>
					<div>
						<span className={`text-xs hidden ${responsive ? 'md:inline' : ''}`}>Written by</span>
						<h5 className={`text-slate-700 text-xs dark:text-slate-300 flex items-center space-x-1 ${responsive ? 'md:text-black dark:md:text-white md:text-sm md:space-x-0' : ''}`}>
							<i className={`bx bx-edit ${responsive ? 'md:hidden' : ''}`}></i>
							<span>Felix Adegboyega</span>
						</h5>
					</div>
				</Link> */}
			</div>
		</div>
	)
}

export default PostCard